import DataMigration from './DataMigration';

export default DataMigration;
